// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cfedab2e","465":"48267ba1","726":"8949fc63"}[chunkId] + ".chunk.js";
};